module.exports = __webpack_public_path__ + "img/word2.9f6c1ba7.png";